import { FilterBaseDto } from '../common/filters/filterBase.dto';
export class LeadFilter extends FilterBaseDto {

}
